import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { TimeoutEventService } from './timeout-event.service';
import { swalMini } from '../../../../shared/utils/utils';
import { RolesService } from '../../../../core/services/roles/roles.service';
import { SharedService } from '../../../../core/services/store/shared-store/shared-storage.service';
import { FlowManagerService } from '../../../flow/services/flow-manager.service';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';

enum TimeOutState {
    LOADING,
    LOADED,
    ERROR
}

@Component({
  selector: 'app-timeout-event',
  templateUrl: './timeout-event.component.html',
  styleUrls: ['./timeout-event.component.scss']
})
export class TimeoutEventComponent implements OnInit, OnDestroy {

  public readonly TimeOutState = TimeOutState;

  public isApiActive= TimeOutState.LOADING;
  public timeoutEventForm: FormGroup;

  public isUserCanEdit= true;
  public isFormDataValid = false;
  public isButtonActive = false;
  public isSaving;
  public isCancelling;

  public getValues: boolean;
  public channelListObj: any;
  public channels = [];
  public supportedChannelsData$: [];
  public timeoutArray: any[];
  public current: string;
  public default;
  public channelsLoaded = false;
  private originalDuration;
  private originalEnabled;
  public $flowId;

  constructor(
      private timeoutService: TimeoutEventService,
      private rolesService: RolesService,
      private sharedService: SharedService,
      private flowManagerService: FlowManagerService,
      private router: Router
  ) {}

  ngOnChanges() {
    this.isSaving = false;
    this.isSaving = false;
  }

  ngOnInit() {
   this.isUserCanEdit = this.rolesService.canEditEndpoints(this.sharedService.getEnvironment());
   this.getTimeoutVars();
   this.getAllChannels();
   this.timeoutEventForm = new FormGroup({
     'selectTimeoutTrigger': new FormControl(this.default,Validators.required),
     'selectTimeoutToggle': new FormControl()
   });
  }

  ngOnDestroy() {
      this.isApiActive = TimeOutState.LOADING;
    }

  getTimeoutVars() {
    this.timeoutService.getFeatureContent().subscribe(
        (data) => {
          this.isApiActive = TimeOutState.LOADED;

          let currentFeature;
            for (let featureItem of data.body.features) {
                if (featureItem['feature']==="EVENT_TRIGGERS") {
                    currentFeature = featureItem;
                }
            }
          let currentDuration = currentFeature.additionalData ? currentFeature.additionalData['timeout-durationMs'] : 60000;
          let enabledFlag = currentFeature.enabled ? currentFeature.enabled : data.body.features.enabled;
          this.timeoutEventForm.get('selectTimeoutToggle').setValue(enabledFlag);
          this.isButtonActive = !enabledFlag;

          this.originalDuration = currentDuration;
          this.originalEnabled = enabledFlag;

          if (enabledFlag) {
              this.$flowId = this.timeoutService.getFlowId();
          }

          let tms = [], holdTime = 300000, mean=10000;
          while(holdTime >= 0) {
            let currentValue= holdTime/mean * 10;
            tms.push(currentValue);
            holdTime = holdTime - mean;
          }

          tms.push(0);
          tms = tms.reverse().slice(1);
          this.timeoutArray = tms;

          if(currentDuration!=='NA') {
              let defaultValue = this.timeoutArray.findIndex(val => val === (currentDuration/1000));
              this.current = `${tms[defaultValue]}s`;
              this.default = defaultValue;
              this.originalDuration = this.default;
              this.timeoutEventForm.get('selectTimeoutTrigger').setValue(this.default);
            }
          else{
              this.current = `60s`;
          }

        }, (data) => {
          this.isApiActive = TimeOutState.ERROR;
          this.timeoutArray= [];
          swalMini({
            title: 'There is an issue with the API',
            text: '',
            type: 'error',
          });
        });
  }

  getAllChannels() {
        this.flowManagerService.getChannelList(true).pipe(
            tap((resp: any) => {
                    if (resp.status === 200) {
                        this.getValues = true;
                        const holderValues = resp.body;
                        for (const holderItem in holderValues) {
                            let currentHolderObject = {
                              channelName: holderValues[holderItem]['channel-name'],
                              sessionLength: holderValues[holderItem]['session-length']
                            };

                            this.channelListObj = {
                                ...this.channelListObj,
                                [currentHolderObject.channelName]: this.toHoursMinutesSeconds(currentHolderObject.sessionLength)
                            };
                        }
                        return this.supportedChannelsData$ = this.channelListObj;
                    } else {
                        this.getValues = false;
                    }
                }
            )
        ).subscribe(
            () => {
            },
            () => {
                this.channelsLoaded = false;
            },
            () => {
                this.channelsLoaded = true;
                this.channels = this.supportedChannelsData$;
            }
        );
  }

  checkFormIsValid() {
        return this.isUserCanEdit && this.timeoutEventForm.valid;
  }

  toHoursMinutesSeconds(totalSeconds) {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  toggleCheckHandler($event: MatSlideToggleChange) {
    if (!$event.checked) {
      this.timeoutEventForm.controls['selectTimeoutTrigger'].disable();
      this.isButtonActive = true;
      this.current = '60s';
    } else {
      this.timeoutEventForm.controls['selectTimeoutTrigger'].enable();
      this.isButtonActive = false;
      this.current = this.default.toString();
    }
    this.isFormDataValid = this.checkFormIsValid();
  }

  saveTimeoutFlow() {
    let stageTimeoutSessionRequest = {}
    if (this.timeoutEventForm.get('selectTimeoutToggle').value===false) {
        stageTimeoutSessionRequest = {
            "features": [{
                feature: 'EVENT_TRIGGERS',
                enabled: this.timeoutEventForm.get('selectTimeoutToggle').value
            }]
        };
    } else {
        stageTimeoutSessionRequest = {
            "features": [{
                feature: 'EVENT_TRIGGERS',
                enabled: this.timeoutEventForm.get('selectTimeoutToggle').value,
                additionalData: {
                    "timeout-durationMs": this.timeoutEventForm.get('selectTimeoutTrigger').value * 10000
                }
            }]
        };
    }

    this.timeoutService.setFeatureContent(stageTimeoutSessionRequest).subscribe(
        (data) => {
          this.isSaving = true;
          if(data.status === 200) {
            swalMini({
              title: 'Saved successfully!',
              text: '',
              type: 'success',
            });
          }
        },error => {
      this.isSaving = false;
      swalMini({
        title: 'Problem occurred while saving',
        text: '',
        type: 'warning',
      });
    },
        () => {
            this.isSaving = false;
            if (this.timeoutEventForm.get('selectTimeoutTrigger').value) {
                this.$flowId = this.timeoutService.getFlowId();
                this.sharedService.setNewFlowSaved(true);
            }
        }
    );
  }

  openTimeOutFlow(flowId) {
        this.router.navigate([`/flow/${this.sharedService.getEnvironment()}/${this.sharedService.getEntityType()}/${this.sharedService.getEntityId()}/${flowId}`])
  }

  cancel() {
    this.timeoutEventForm.reset();
    this.timeoutEventForm.get("selectTimeoutTrigger").setValue(this.originalDuration);
    this.timeoutEventForm.get("selectTimeoutToggle").setValue(this.originalEnabled);
    this.isButtonActive = !this.originalEnabled;
  }

  selectTriggerOption($event: MouseEvent) {
        if(!this.isButtonActive) {
            this.timeoutEventForm.markAsDirty();
            this.isUserCanEdit = true;
            this.isFormDataValid = this.checkFormIsValid();
        } else {
            this.timeoutEventForm.markAsPristine();
            this.timeoutEventForm.markAsUntouched();
        }
    }

  public keepOrder = (a, b) => {
    return a;
  }

  compareWith(value, option) {
   return value === option.toString();
  }

}

